import VisualWorkflowBuilderV2 from 'cio/components/visual-workflow-builder-v2';
import { StickyNotesManager, StickyNotesManagerParams } from 'cio/utils/visual-workflow-builder/notes';
import { ZoomManager, ZoomManagerParams } from 'cio/utils/visual-workflow-builder/zoom';
import { InertiaManager, InertiaManagerParams } from 'cio/utils/visual-workflow-builder/inertia';

export type VWBContext = {
  stickyNotesManager: StickyNotesManager;
  zoomManager: ZoomManager;
  inertiaManager: InertiaManager;
};

export class VWBComponentWrapper implements StickyNotesManagerParams, ZoomManagerParams, InertiaManagerParams {
  vwbComponent: VisualWorkflowBuilderV2;

  constructor(vwbComponent: VisualWorkflowBuilderV2) {
    this.vwbComponent = vwbComponent;
  }

  get campaign() {
    return this.vwbComponent.args.campaign;
  }

  get graphElement() {
    return this.vwbComponent.graphElement;
  }

  get canvas() {
    return this.vwbComponent.canvas;
  }

  get inViewport() {
    return this.vwbComponent.inViewport;
  }

  get loaded() {
    return this.vwbComponent.loaded;
  }

  get isCopyingFrom() {
    return this.vwbComponent.args.isCopyingFrom ?? false;
  }

  get isCopyingTo() {
    return this.vwbComponent.args.isCopyingTo ?? false;
  }

  get isMinimapMode() {
    return this.vwbComponent.args.isMinimapMode ?? false;
  }

  get isReadOnly() {
    return this.vwbComponent.args.isReadOnly ?? false;
  }

  get zoomLevel() {
    return this.vwbComponent.zoomManager.zoomLevel;
  }

  get tab() {
    return this.vwbComponent.args.tab;
  }

  get isShowingCopyFromModal() {
    return this.vwbComponent.isShowingCopyFromModal;
  }

  get isShowingCopyToModal() {
    return this.vwbComponent.isShowingCopyToModal;
  }

  get offsetX() {
    return this.vwbComponent.offsetX;
  }

  get offsetY() {
    return this.vwbComponent.offsetY;
  }

  get width() {
    return this.vwbComponent.width;
  }

  get height() {
    return this.vwbComponent.height;
  }

  get initialZoomLevel() {
    return this.vwbComponent.args.initialZoomLevel;
  }

  get minZoomLevel() {
    return this.vwbComponent.args.minZoomLevel;
  }

  get maxZoomLevel() {
    return this.vwbComponent.args.maxZoomLevel;
  }

  get pathStrokeWidth() {
    return this.vwbComponent.pathStrokeWidth;
  }

  get stickyNotesEnabled() {
    return this.vwbComponent.stickyNotesEnabled;
  }

  get isMouseDown() {
    return this.vwbComponent.isMouseDown;
  }

  setPathStrokeWidth(value: number) {
    this.vwbComponent.pathStrokeWidth = value;
  }
}
